import { AiOutlineExclamationCircle } from 'react-icons/ai';

type Props = {
  title: string;
  message: string;
  className?: string;
};

const CardInstruction = ({ title, message, className = '' }: Props) => {
  return (
    <div className={'flex flex-col items-start w-full p-6 bg-gradient-to-br from-blue-50 to-indigo-50/50 rounded-xl border border-blue-100 gap-2 ' + className}>
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-500/10">
          <AiOutlineExclamationCircle className="h-5 w-5 text-blue-600" />
        </div>
        <h4 className="text-base font-semibold text-slate-900">{title || 'title'}</h4>
      </div>
      <div
        className="w-full text-justify text-sm leading-relaxed text-slate-600 [&_p]:mb-3 [&_p]:text-justify [&_p]:last:mb-0 [&_h5]:mb-2 [&_h5]:mt-4 [&_h5]:text-left [&_h5]:text-sm [&_h5]:font-semibold [&_h5]:text-slate-800 [&_strong]:font-medium [&_strong]:text-slate-800 [&_ul]:ml-4 [&_ul]:list-disc [&_li]:mb-1 [&_li]:text-justify"
        dangerouslySetInnerHTML={{ __html: message || 'message' }}
      />
    </div>
  );
};

export { CardInstruction };
